module.exports = __webpack_public_path__ + "static/media/its.b5214e6c.png";